import { Description } from "./styles";

export function AlertDescription({ children, ...rest }) {
  return <Description {...rest}>{children}</Description>;
}
